<template>
	<div class="action" v-if="task.id">
		<div>
	        <a-button type="danger" @click="visible=true">{{rejectButtonName}}</a-button>
	        <a-button type="primary" :loading="loading" @click="approval('pass')">{{buttonName}}</a-button>
	    </div>
	    <a-modal :title="title" :visible="visible" :footer="null" width="40%" @cancel="visible=false">
	      	<a-textarea placeholder="请录入意见" v-model="comment" :rows="4"/>
	      	<div class="butFrames">
	      		<a-button type="danger" :loading="loading" @click="approval('reject')">确认驳回</a-button>
	      	</div>
	    </a-modal>
	</div>
</template>

<script>
export default {
    props:{
        type:String,
		uuid:String,
		brokerApprovalOpinion: {
			type: String,
			default: ''
		},
		buttonName: {
			type: String,
			default: '通过'
		},
		rejectButtonName: {
			type: String,
			default: '驳回'
		},
		title: {
			type: String,
			default: '审批'
		}
    },
    data() {
        return {
            task: {},
            visible:false,
            comment: "",
			loading: false,
        }
    },
	watch: {
		uuid: {
			handler(newVal, oldVal) {
				this.task = {};
				if(newVal){
					this.uuid = newVal;
					this.init();
				}
			},
			deep: true
		},
	},
    methods:{
    	init(){
    		this.$get(`flowTask/userTask/${this.type}/${this.uuid}`).then(res => {
	    		if(res.data){
	    			this.task = res.data;
	    		}else{
	    			this.task = {};
	    		}
	    	});
    	},
    	approval(approvalType){
    		if(approvalType == 'reject' && (!this.comment || !(String(this.comment).trim()))){
    			this.$message.warning("请录入处理意见");
    			return;
    		}
			//审批通过时处理意见必填 并判断必填字段是否填写
			this.$post("accountPriceApply/saveBrokerApprovalOpinion", {approvalType: approvalType,uuid: this.uuid, brokerApprovalOpinion: this.brokerApprovalOpinion}).then(res => {
				this.dealApproval(approvalType);
			});
    	},
		dealApproval(approvalType){
			this.loading = true;
			this.$post("flowTask/approval",{taskId:this.task.id,approvalType:approvalType,comment:this.comment||'通过'}).then(res => {
				this.loading = false;
				this.comment = "";
				this.$message.success("操作成功");
				this.init();
				this.visible = false;
				this.$emit('success');
				this.$emit('accountPriceHome');
			}).catch(e => {
				this.init();
				this.loading = false;
			});
		}
    }
}
</script>
<style lang="less" scoped>
	.butFrames{
		display: flex;
		justify-content: center;
		padding-top: 30px;
		button{
			width: 20%;
			margin: 0 3%;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/account/accountChange/accountPrice/approval.vue